/**
 * List of rules
 */
const rules = {
  required       : '必ず指定してください。',
  requiredIf     : '必ず指定してください。',
  numeric        : '数字を指定してください。',
  minLength      : ':min文字以上にしてください。',
  maxLength      : ':max文字以下にしてください。',
  min            : ':min以上の数字を指定してください。',
  max            : ':max以下の数字を指定してください。',
  email          : '有効なメールアドレス形式で指定してください。',
  size           : ':size文字にしてください。',
  sameAs         : ':attributeが一致しません。',
  alphaNum       : "英数字('A-Z','a-z','0-9')が使用できます。",
  apply          : '上記内容をご確認の上、「上記内容に同意して退会する」へチェックを入れてください。',
  loginId        : '英数字を指定してください。',
  password       : '英数字記号を指定してください。',
  katakana       : 'カタカナを指定してください。',
  cardHolder     : 'アルファベット大文字を指定してください。',
  chiban         : '漢数字、読点[,][、]、記号[+]又は空白が含まれています。',
  duplicated     : '重複した物件があります。',
  incident       : '事件情報を選択してください',
  duplicatedEmail: 'メールアドレスが重複しています。',
};

/**
 * List of attributes
 */
const attributes = {
  loginId                : 'ログインID',
  numberAccount          : 'ユーザー数',
  emailAddress           : 'メールアドレス',
  email                  : 'メールアドレス',
  username               : 'ユーザー名',
  password               : 'パスワード',
  passwordConfirm        : 'パスワードの確認',
  selectLog              : '種類',
  startDate              : '開始日時',
  finishDate             : '終了日時',
  pdfType                : '種類',
  corporationName        : "法人名",
  corporationKana        : "法人名（カナ）",
  corporationBranchName  : "支店名",
  corporationPostal      : "郵便番号",
  corporationAddressPref : "住所.都道府県",
  corporationAddressCity : "住所.市区町村",
  corporationStreetName  : "住所.町名",
  corporationStreetNumber: "住所.番地",
  corporationAddressEtc  : "住所.建物名・部屋番号等",
  corporationTel         : "電話番号",
  corporationEmail       : "メールアドレス",
  accountLastName        : "アカウント姓",
  accountFirstName       : "アカウント名",
  accountLastKana        : "アカウント姓（カナ）",
  accountFirstKana       : "アカウント名（カナ）",
  contractReason         : "申し込みのきっかけ",
  apply                  : '利用規約へ同意する',
  logType                : 'ログの種類',
  startLogDate           : '期間.開始',
  endLogDate             : '期間.終了',
  informationDate        : 'お知らせ日',
  subject                : '件名',
  body                   : '本文',
  publicationBegin       : '掲載日時.開始',
  publicationEnd         : '掲載日時.終了',
  paymentLabel           : '支払情報の名称',
  paymentBillMethod      : '決済方法',
  paymentCardNumber      : 'カード番号',
  paymentCardExpiredMonth: '有効月',
  paymentCardExpiredYear : '有効年',
  paymentCardSecurityCode: 'セキュリティコード',
  paymentBillVia         : '請求書の送付方法',
  paymentName1           : '法人名',
  paymentName2           : '部署名',
  paymentName3           : 'ご担当者名',
  paymentPostal          : '郵便番号',
  paymentPref            : '都道府県',
  paymentCity            : '市区町村',
  paymentStreetName      : '町名',
  paymentStreetNumber    : '番地',
  paymentEmail           : 'メールアドレス',
  adminLastName          : '管理者氏名.姓',
  adminFirstName         : '管理者氏名.名',
  group                  : '部門',
  groupName              : '部門名',
  role                   : '権限',
  firstName              : '氏名.名',
  lastName               : '氏名.姓',
  firstKana              : '氏名.メイ',
  lastKana               : '氏名.セイ',
  userId                 : 'ユーザーID',
  tServiceID             : '登記情報提供サービスID',
  gmoMemberId            : '決済方法',
  parcelNumber           : '地番',
};


const regex = {
  hyphens: /[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━₋]+/g,
  kanji  : /[〇一二三四五六七八九十百千]+/u,
}

const Validation = {
  rules     : rules,
  attributes: attributes,
  regex     : regex,
  // Custom rule: value must be true
  mustBeTrue: (value) => value === true,
  /**
   * Get validation message
   *
   * @param message
   * @param attribute
   * @param param
   * @returns {*}
   */
  errorMessage: function (message, attribute, param = null) {
    let result = message.replace(':attribute', this.attributes[attribute]);
    if (param === null) {
      return result;
    }
    if (message === this.rules.maxLength || message === this.rules.max) {
      return result.replace(':max', param).replace(':size', param);
    }
    if (message === this.rules.minLength || message === this.rules.min) {
      return result.replace(':min', param).replace(':size', param);
    }
    if (message === this.rules.size) {
      return result.replace(':max', param).replace(':min', param).replace(':size', param);
    }
    return result;
  },
  /**
   * バリデーション.ログインID
   *
   * @param value
   */
  loginId: function (value) {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true;
    }
    return /^[0-9a-zA-Z-]*$/.test(value);
  },
  /**
   * バリデーション.パスワード
   *
   * @param value
   */
  password: function (value) {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true;
    }
    return /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(value);
  },
  /**
   * バリデーション.カタカナ
   *
   * @param value
   */
  katakana: function (value) {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true;
    }
    return /^[ァ-ンヴー\s]*$/.test(value);
  },
  /**
   * バリデーション.名義人
   *
   * @param value
   */
  cardHolder: function (value) {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true;
    }
    return /^[A-Z\s]*$/.test(value);
  },
  /**
   * 漢数字か
   * @param value
   */
  japaneseNumberCharacter: function (value) {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true;
    }
    return regex.kanji.test(value);
  },
  /**
   * 記号か
   * @param value
   */
  symbolCharacter: function (value) {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true;
    }
    const halfValue = value.replace(/[！-～]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0));
    const formatted = halfValue.replace(regex.hyphens, '-');
    return !/^[^\,\+、\s]*$/.test(formatted);
  },
  /**
   * バリデーション.地番
   * ※読点[,][、]、記号[+]又は空白は利用できない
   *
   * @param value
   */
  chiban: function (value) {
    if (typeof value === 'undefined' || value === null || value === '') {
      return true;
    }
    // 漢数字のバリデーション
    if (Validation.japaneseNumberCharacter(value)) {
      return false;
    }
    // 記号を半角に変換
    return !Validation.symbolCharacter(value);
  },
};


export default Validation;
